import { ReactElement } from 'react';
import { Text } from '@chakra-ui/react';

import { PropsWithChildren } from 'lib/@types';

const CardTitle = ({ children }: PropsWithChildren): ReactElement => (
  <Text
    fontSize={['14px', '16px']}
    color='primary.500'
    fontWeight='600'
    mb='0.5'
  >
    {children}
  </Text>
);

export default CardTitle;
